<template>
  <div class="wlx-stuy-text-crity-wrapper">
     <div>
      <div class="search-input-con">
        <el-input v-model="search" size="small" style="width:220px;" placeholder="请输入活动标题"/>
        <el-button style="margin-left: 10px;" size="small" type="primary" icon="el-icon-search">搜索</el-button>
      </div>
      <el-table
        :data="enrollList.filter(data => !search || data.Title.toLowerCase().includes(search.toLowerCase()))"
        style="width: 100%"
      >
        <el-table-column label="序号" type="index"></el-table-column>
        <el-table-column label="活动标题" prop="Title"></el-table-column>
        <el-table-column label="内容" prop="Title"></el-table-column>
        <el-table-column label="发布站点" prop="SiteName"></el-table-column>
        <el-table-column label="所属省份" prop="SiteName"></el-table-column>
        <el-table-column label="开始时间" prop="DateCreated"></el-table-column>
        <el-table-column label="结束时间" prop="DateCreated"></el-table-column>
        <el-table-column label="报名时间" prop="DateCreated"></el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope">
            <div style="color: #2D82FF" v-if="scope.row.IsAdop==0">等待处理</div>
            <div style="color: #05C94F" v-if="scope.row.IsAdop==1">已通过</div>
            <div style="color: #E53939" v-if="scope.row.IsAdop==2">未通过</div>
          </template>
        </el-table-column>
      </el-table>
      <div class="u-page-con">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageIndex"
          :page-sizes="[10, 15, 20, 30]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalCount"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      attestationList: [],
      SiteList: [],
      siteId_: "",
      attestationId: "",
      dialogVisible: false,
      enrollList: [],
      search: "",
      pageIndex: 1,
      pageSize: 10,
      totalCount: 10,
      dilpageIndex: 1,
      dilpageSize: 10,
      diltotalCount: 10,
      radio: ""
    };
  },
  components: {},
  created() {
    this.getSiteList();
    this.getAttestationStu();
    this.getAttestationList();
  },
  methods: {
    dilhandleSizeChange(size) {
      this.dilpageSize = size;
      this.getAttestationList();
    },
    dilhandleCurrentChange(index) {
      this.dilpageIndex = index;
      this.getAttestationList();
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.getAttestationStu();
    },
    handleCurrentChange(index) {
      this.pageIndex = index;
      this.getAttestationStu();
    },
    getSiteList() {
      var that = this;
      this.$http
        .post("/api/XOrg/StudentManager/getSiteList", { type: 4 })
        .then(function(rst) {
          if (rst.code > 0) {
            that.SiteList = rst.SiteList;
          } else {
            that.$message.warning(rst.msg);
          }
        });
    },
    handleClose() {
      this.dialogVisible = false;
    },
    siteChange() {
      this.attestationId = "";
      this.getAttestationList();
    },
    getAttestationList() {
      var that = this;
      this.$http
        .post("/api/XOrg/StudentManager/getAttestationList", {
          SiteId: that.siteId_,
          type: 4,
          page: that.pageIndex
        })
        .then(function(rst) {
          if (rst.code > 0) {
            that.attestationList = rst.attestationList;
            that.dilpageIndex = rst.pagination.pageIndex;
            that.dilpageSize = rst.pagination.pageSize;
            that.diltotalCount = rst.pagination.totalCount;
          } else {
            that.$message.warning(rst.msg);
          }
        });
    },
    submit() {
      var that = this;
      this.$http
        .post("/api/XOrg/StudentManager/addAttestationStu", {
          attestationId: this.attestationId,
          type: 4
        })
        .then(function(rst) {
          if (rst.code > 0) {
            that.$message.success(rst.msg);
            that.dialogVisible = false;
            that.getAttestationStu();
          } else {
            that.$message.warning(rst.msg);
          }
        });
    },
    getAttestationStu() {
      var that = this;
      this.$http
        .post("/api/XOrg/StudentManager/getAttestationStu", {
          type: 4,
          page: this.pageIndex
        })
        .then(function(rst) {
          if (rst.code > 0) {
            that.enrollList = rst.enrollList;
            that.pageIndex = rst.pagination.pageIndex;
            that.pageSize = rst.pagination.pageSize;
            that.totalCount = rst.pagination.totalCount;
          } else {
            that.$message.warning(rst.msg);
          }
        });
    }
  }
};
</script>

<style lang="scss">
.wlx-stuy-text-crity-wrapper {
  .search-input-con {
    padding: 10px;
    background: #fff;
    text-align: right;
    border-bottom: 1px solid #e7ecf4;
  }
  .sign-up-btn {
    margin: 13px 62px 0 0;
  }
}
</style>